import { render, staticRenderFns } from "./SchoolTeacherForm.vue?vue&type=template&id=7f0a2ddd&scoped=true"
import script from "./SchoolTeacherForm.vue?vue&type=script&lang=js"
export * from "./SchoolTeacherForm.vue?vue&type=script&lang=js"
import style0 from "./SchoolTeacherForm.vue?vue&type=style&index=0&id=7f0a2ddd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0a2ddd",
  null
  
)

export default component.exports